/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {
    SET_TRANSACTIONS(state, transactions) {
        state.transactions = transactions
        state.loading = false
    },
    SET_TRANSACTION(state, transaction) {
        state.transaction = transaction
        state.loading = false
    },
    SET_SEARCH_DATA(state, searchData) {
        state.searchData = searchData
    },
    SET_CITY(state, city) {
        state.city = city
    },
    FETCH_TRANSACTIONS(state) {
        state.loading = true
    },
    GET_TRANSACTION(state) {
        state.loading = true
    },
    FETCH_SEARCH_DATA() {
        // state.loading = true
    },
    // SET_LABELS(state, labels) {
    //   state.eventLabels = labels
    // },
    ADD_TRANSACTION(state, transaction) {
        state.transactions.unshift(transaction)
    },
    REMOVE_ITEM(state, itemId) {
        const ItemIndex = state.transactions.findIndex((p) => p.id == itemId)
        state.transactions.splice(ItemIndex, 1)
    },
}